var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "header-phone" }, [
    _c("div", { staticClass: "container" }, [
      _c("p", { staticClass: "header-phone" }, [
        _vm.linkType === "tel:"
          ? _c("i", { staticClass: "fa fa-phone" })
          : _vm.linkType === "mailto:"
          ? _c("i", { staticClass: "fa fa-envelope" })
          : _vm._e(),
        _vm._v(" "),
        _c("a", { attrs: { href: _vm.linkType + _vm.link } }, [
          _vm._v(
            _vm._s(
              _vm.link +
                (this.$userIsAdmin || _vm.linkType === "mailto:"
                  ? ""
                  : " Support Hotline")
            )
          ),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }